export default function InternalError() {
    return (
        <div className="d-flex flex-column flex-root">
            <div
                className="error error-5 d-flex flex-row-fluid bgi-size-cover bgi-position-center"
                style={{
                    backgroundImage:
                        "url(https://preview.keenthemes.com/metronic/theme/html/demo7/dist/assets/media/error/bg5.jpg)",
                    minHeight: "750px",
                }}
            >
                <div className="container d-flex flex-row-fluid flex-column justify-content-md-center p-12">
                    <h1
                        className="error-title font-weight-boldest mt-10 mt-md-0 mb-12"
                        style={{ color: "var(--capys)" }}
                    >
                        Ops!
                    </h1>
                    <p className="font-weight-boldest display-4">
                        Erro interno no Sistema
                    </p>
                    <p className="font-size-h3">
                        Estamos trabalhando para resolver este problema!
                    </p>
                </div>
            </div>
        </div>
    );
}
